export default [
  {
    path: '/post-search',
    name: 'post-search',
    component: () => import('@/views/PostSearch/PostSearch.vue'),
    meta: {
      protected: true,
      pageTitle: 'Post Search',
      breadcrumb: [
        {
          text: 'Post Search',
          active: true,
        },
      ],
    },
  },
  {
    path: '/post/:id',
    name: 'post-view',
    props: true,
    component: () => import('@/views/postView/PostView.vue'),
    meta: {
      protected: true,
    },
  },
]
